import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const DEFAULT_SITE =
  (typeof process !== "undefined" &&
    process.env.REACT_APP_PUBLIC_SITE_URL?.replace(/\/$/, "")) ||
  "https://portal.softindex.ro";

export default function PortalSeo() {
  const { pathname } = useLocation();
  const isAuthEntry = pathname === "/auth";
  const canonicalAuth = `${DEFAULT_SITE}/auth`;

  if (isAuthEntry) {
    return (
      <Helmet>
        <meta name="robots" content="index, follow" />
        <title>Softindex Portal — Sign in</title>
        <meta
          name="description"
          content="Sign in to the Softindex client portal. Access is for invited users or approved Google sign-in."
        />
        <link rel="canonical" href={canonicalAuth} />
        <meta property="og:title" content="Softindex Portal — Sign in" />
        <meta
          property="og:description"
          content="Sign in to the Softindex client portal."
        />
        <meta property="og:url" content={canonicalAuth} />
        <meta property="og:type" content="website" />
      </Helmet>
    );
  }

  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}
